export const NotificationDotLabel = ({
  children,
  show,
}: {
  children: React.ReactNode
  show: boolean
}) => (
  <span className="flex min-w-0 flex-1 items-center gap-1.5">
    <span className="truncate">{children}</span>
    {show && (
      <span
        aria-label="New"
        className="size-2 shrink-0 rounded-full bg-red-500"
      />
    )}
  </span>
)
